// @ts-expect-error untyped module
import { getIsUngatedForUnifiedStorefront } from '../selectors/auth';
import PortalIdParser from 'PortalIdParser';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
export function UnifiedStorefrontRedirect() {
  const {
    pathname,
    search
  } = useLocation();
  const isUngatedForUnifiedStorefront = useSelector(getIsUngatedForUnifiedStorefront);
  useEffect(() => {
    if (isUngatedForUnifiedStorefront) {
      window.location.href = `/marketplace/${PortalIdParser.get()}/apps${pathname}${search}`;
    }
  }, [isUngatedForUnifiedStorefront, pathname, search]);
  return null;
}